import { render, staticRenderFns } from "./aoi-config-dialog.vue?vue&type=template&id=5c5ab228&"
import script from "./aoi-config-dialog.vue?vue&type=script&lang=js&"
export * from "./aoi-config-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports